import { apiClient } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { 
  FeedTypesResponse, 
  FeedListResponse, 
  CreateFeedResponse, 
  CreateFeedRequest,
  FeedListParams,
  Feed
} from '@/constants/types';
export interface FeedDetailsResponse {
  success: boolean;
  data: {
    feed:Feed;
  };
}

export const feedService = {
  getFeedTypes: async (): Promise<FeedTypesResponse> => {
    const response = await apiClient.get(API_ENDPOINTS.FEED.FEED_TYPES);
    return response.data;
  },

  getFeeds: async (params: FeedListParams = {}): Promise<FeedListResponse> => {
    const queryParams = new URLSearchParams();

    if (params.feedType) queryParams.append('feedType', params.feedType);
    if (params.visibility) queryParams.append('visibility', params.visibility);
    if (params.tags) queryParams.append('tags', params.tags);
    if (params.search) queryParams.append('search', params.search);
    if (params.userId) queryParams.append('userId', params.userId);
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.hasAttachment) queryParams.append('hasAttachment', params.hasAttachment.toString());
    // Job-specific filters
    if (params.location) queryParams.append('location', params.location);
    if (params.experienceLevel) queryParams.append('experienceLevel', params.experienceLevel);
    if (params.jobType) queryParams.append('jobType', params.jobType);
    if (params.minSalary) queryParams.append('minSalary', params.minSalary);
    if (params.maxSalary) queryParams.append('maxSalary', params.maxSalary);
    if (params.salaryDenomination) queryParams.append('salaryDenomination', params.salaryDenomination);
    if (params.salaryPeriod) queryParams.append('salaryPeriod', params.salaryPeriod);

    const url = `${API_ENDPOINTS.FEED.FEEDS}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiClient.get(url);
    return response.data;
  },

  createFeed: async (feedData: CreateFeedRequest): Promise<CreateFeedResponse> => {
    const response = await apiClient.post(API_ENDPOINTS.FEED.CREATE_FEED, feedData);
    return response.data;
  },
  // Get feed details (for getting updated stats)
  getFeedDetails: async (feedId: string): Promise<FeedDetailsResponse> => {
    const response = await apiClient.get(`/feeds/${feedId}`);
    return response;
  },

  // Apply for a job
  applyForJob: async (feedId: string): Promise<any> => {
    const response = await apiClient.post(API_ENDPOINTS.FEED.APPLY, { feedId });
    return response.data;
  },

  getMyFeeds: async (params: FeedListParams = {}): Promise<FeedListResponse> => {
    const queryParams = new URLSearchParams();
    
    if (params.feedType) queryParams.append('feedType', params.feedType);
    if (params.visibility) queryParams.append('visibility', params.visibility);
    if (params.tags) queryParams.append('tags', params.tags);
    if (params.search) queryParams.append('search', params.search);
    if (params.type) queryParams.append('type', params.type);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.hasAttachment) queryParams.append('hasAttachment', params.hasAttachment.toString());

    const url = `${API_ENDPOINTS.FEED.MY_FEEDS}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiClient.get(url);
    return response.data;
  },

  updatePostStatus: async (feedId: string, isActive: boolean): Promise<any> => {
    const response = await apiClient.patch(`/feeds/${feedId}/status`, { isActive });
    return response.data;
  },

  deleteFeed: async (feedId: string): Promise<any> => {
    const response = await apiClient.delete(API_ENDPOINTS.FEED.DELETE_FEED(feedId));
    return response.data;
  },

  reportFeed: async (feedId: string, reason: string): Promise<any> => {
    const response = await apiClient.post(API_ENDPOINTS.FEED.REPORT, { feedId, reason });
    return response.data;
  },
  votePoll: async (feedId: string, optionIndex: number): Promise<any> => {
    const response = await apiClient.post(API_ENDPOINTS.FEED.VOTE_POLL(feedId), { optionIndex });
    return response.data;
  },

  getTopSuperAdminPosts: async (): Promise<any> => {
    return await apiClient.get(API_ENDPOINTS.FEED.SUPER_ADMIN_TOP_5);
  }
};